module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M26 20h-2v-8h2c3.32 0 6-2.68 6-6s-2.68-6-6-6-6 2.68-6 6v2h-8V6c0-3.32-2.68-6-6-6S0 2.68 0 6s2.68 6 6 6h2v8H6c-3.32 0-6 2.68-6 6s2.68 6 6 6 6-2.68 6-6v-2h8v2c0 3.32 2.68 6 6 6s6-2.68 6-6c0-1.66-.68-3.16-1.76-4.24S27.66 20 26 20zM8 27a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h3v3zM23.998 5.002a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H24V6h-.002v-.998zM5 8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3H5zm15 12h-8v-8h8v8zm8 6.998a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3h3a1 1 0 0 1 1 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/command-1.js
// module id = 1080
// module chunks = 14